<template>
	<div class="billing_displayer">
		<h4 id="displayer__title">Commentaires Résa</h4>
		<span v-if="booking.message" v-html="booking.message"></span>
		<span v-else-if="booking.booking_multiple"><!--bookingMultiple-->
			<span v-if="booking.booking_multiple.comment">
				<b>Remarque réservation :</b><br>
				<span v-html="booking.booking_multiple.comment"></span>
			</span>
			<span v-if="booking.comment">
				<b>Commentaire client :</b><br>
				<span v-html="booking.comment"></span>
			</span>
		</span>
		<span v-else>Aucun commentaire</span>
		<span v-if="transferAmount" style="margin:0">
			<h4 id="payment_title">Paiement Reçu</h4>
			<span style="margin-left:10px">{{transferAmount/100}} €</span>
		</span>
	</div>
</template>

<script>
export default {

  name: 'bookingCommentsComponent',
  props: ['relatedBooking','transferAmount'],
  data () {
    return {
		booking: Object.assign({}, this.relatedBooking),
    }
  }
}
</script>

<style lang="css" scoped>
.billing_displayer{
	width: 25rem;
	position: fixed;
	background-color: white;
	right: 0;
	top: 12rem;
	border-radius: 5px 0 0 5px!important;
	box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.40);
	z-index: 1000;
	display: block;
}

.billing_displayer>span{
	margin-left: 1rem;
	display: block;
}

h4{
	background-color: #26344b;
	margin: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	color: white;
	font-weight: 500;
}
#displayer__title{
	padding: 1rem;
	border-radius: 5px 0 0 0!important;
}
</style>
